class InitialDataService {

  constructor(
    $http,
    $state,
    $log,
    AuthenticationService,
    LoansUserDataService,
    LoansOperationsService,
    LoansEmployeeRepositoryService) {
    'ngInject';

    this.$http = $http;
    this.state = $state;
    this.log = $log;

    this.employeeRepositoryService = LoansEmployeeRepositoryService;
    this.userDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.employeeId = AuthenticationService.getEmployeeId();
    this.employeeProfileInfo = {};
  }

  initMainData() {
    return this.employeeRepositoryService.getEmployee(this.employeeProfileInfo)
      .then((employee) => {
        this.userDataService.setEmployee(employee);
        return employee;
      });
  }

  getEmployeeProfileInfo() {
    return this.loansOperationsService.getCreditworthiness(this.employeeId)
      .then((creditworthiness) => {
        this.employeeProfileInfo = creditworthiness.employeeProfile;
        this.log.info('getEmployeeProfileInfo', this.employeeProfileInfo);
        return creditworthiness.employeeProfile;
      }, error => {
        this.log.error('getEmployeeProfileInfo', error);

      });
  }
}

export default InitialDataService;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/initialData/initialData.service.js